import React from 'react';
import styles from './index.module.less';
import { Header } from 'antd/lib/layout/layout';
import { theme, Button, Dropdown, Avatar } from 'antd';
import { useNavigate } from 'react-router-dom';
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Service, type ManagerDetailResponseTree } from '@/apis';

const AppHeader: React.FC<{ userInfo: ManagerDetailResponseTree }> = ({
  userInfo,
}) => {
  const navigate = useNavigate();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleLogout = () => {
    let state = true;
    Service.managerControllerSetExit()
      .then(() => {
        // 跳转到登录页
        state = false;
        navigate('/login');
      })
      .finally(() => {
        setTimeout(() => {
          if (state) {
            window.location.reload();
          }
        }, 1000);
      });
  };

  const userMenuItems: MenuProps['items'] = [
    // {
    //   key: 'profile',
    //   icon: <UserOutlined />,
    //   label: '个人资料',
    //   onClick: () => {
    //     // 跳转到个人资料页面
    //     navigate('/profile');
    //   },
    // },
    // {
    //   type: 'divider',
    // },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ];
  return (
    <Header className={styles.header} style={{ background: colorBgContainer }}>
      <aside>
        <img src='/brand/app-icon-rounded.svg' alt='Sinolinkway' />
        <h2>Sinolinkway Management System</h2>
      </aside>
      {userInfo.realName ? (
        <aside>
          <Dropdown menu={{ items: userMenuItems }} placement='bottomRight'>
            <Button
              type='text'
              style={{ display: 'flex', alignItems: 'center', gap: 8 }}
            >
              <Avatar size='small' icon={<UserOutlined />} />
              {userInfo.realName}
            </Button>
          </Dropdown>
        </aside>
      ) : (
        <aside>
          <Button
            type='primary'
            onClick={() => {
              navigate('/login');
            }}
          >
            登录
          </Button>
        </aside>
      )}
    </Header>
  );
};

export default AppHeader;
